import type { StoreGetStoreResponse } from '@/types/redemption'
import { useRuntimeConfig } from '#imports'
import { createApiUtils } from './utils'

const baseUrl = '/redemption/api/store'

type UserClientStoreResponses = {
  getOne: StoreGetStoreResponse
  getAll: StoreGetStoreResponse[]
  switchStore: {
    token: string
    storeId: string
    storeCode: string
    storeName: string
    partnerId: string
  }
}

export const useClientStoreRepository = () => {
  const config = useRuntimeConfig()
  const { execute, getError } = createApiUtils<UserClientStoreResponses>()

  const getOne = (storeId: string) =>
    ({
      url: `${baseUrl}/${storeId}`,
      options: {
        method: 'GET',
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const getAll = () =>
    ({
      url: baseUrl,
      options: {
        method: 'GET',
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const switchStore = (storeId: string) =>
    ({
      url: `${baseUrl}/${storeId}/switch`,
      options: {
        method: 'POST',
        body: {},
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  return {
    getOne,
    getAll,
    switchStore,
    execute,
    getError,
  }
}
